"use strict";
/* tslint:disable */
var TComboSPSlipMode = (function () {
    "use strict";
    var api = {};
    // Overrides ComboSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };
    // Template logic splitter
    api.buildOptions = function (selections) {
        /*globals Modes */
        Modes.calcComboVariants(this);
        /*globals TMultiOptions */
        return TMultiOptions.buildCombo(this, selections) || "";
    };
    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };
    api.buildHeader = function () {
        return "";
    };
    return api;
}());
window.TComboSPSlipMode = TComboSPSlipMode;
//# sourceMappingURL=TComboSPSlipMode.js.map